import ReactGA from 'react-ga4';

// Google Analytics設定
const GA_TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID || 'G-XXXXXXXXXX';

// GA初期化
export const initGA = () => {
  if (GA_TRACKING_ID && GA_TRACKING_ID !== 'G-XXXXXXXXXX') {
    ReactGA.initialize(GA_TRACKING_ID, {
      gtagOptions: {
        send_page_view: false
      }
    });
    console.log('Google Analytics initialized with ID:', GA_TRACKING_ID);
  } else {
    console.warn('Google Analytics tracking ID not configured');
  }
};

// ページビュー追跡
export const trackPageView = (path: string, title?: string) => {
  ReactGA.send({ hitType: 'pageview', page: path, title });
};

// イベント追跡
export const trackEvent = (action: string, category: string, label?: string, value?: number) => {
  ReactGA.event({
    action,
    category,
    label,
    value
  });
};

// カスタムイベント
export const trackCustomEvent = (eventName: string, parameters?: Record<string, any>) => {
  ReactGA.event(eventName, parameters);
};

// 写真関連のイベント
export const trackPhotoEvent = {
  upload: (count: number) => trackEvent('photo_upload', 'photo', 'upload', count),
  delete: (photoId: string) => trackEvent('photo_delete', 'photo', photoId),
  edit: (photoId: string) => trackEvent('photo_edit', 'photo', photoId),
  view: (photoId: string) => trackEvent('photo_view', 'photo', photoId),
  download: (photoId: string) => trackEvent('photo_download', 'photo', photoId),
};

// 写真帳関連のイベント
export const trackLedgerEvent = {
  create: () => trackEvent('ledger_create', 'ledger'),
  print: () => trackEvent('ledger_print', 'ledger'),
  downloadPDF: () => trackEvent('ledger_download_pdf', 'ledger'),
  addPhoto: (photoId: string) => trackEvent('ledger_add_photo', 'ledger', photoId),
  removePhoto: (photoId: string) => trackEvent('ledger_remove_photo', 'ledger', photoId),
};

// ツール関連のイベント
export const trackToolEvent = {
  pdfAnnotation: () => trackEvent('tool_use', 'pdf_annotation'),
  trafficControl: () => trackEvent('tool_use', 'traffic_control'),
  imageConverter: () => trackEvent('tool_use', 'image_converter'),
};

// ユーザー関連のイベント
export const trackUserEvent = {
  login: () => trackEvent('user_login', 'auth'),
  logout: () => trackEvent('user_logout', 'auth'),
  signup: () => trackEvent('user_signup', 'auth'),
};

// エラー追跡
export const trackError = (error: string, fatal: boolean = false) => {
  ReactGA.event('exception', {
    description: error,
    fatal: fatal
  });
};
